<template>
  <td>
    <span v-if="!isDynamic" class="flag-icon" :class="flagClass"></span>
    <span v-html="html"></span>
  </td>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
  props: ["model"],
  computed: {
    html() {
      return this.isDynamic
        ? "dynamisch"
        : this.model.zipcode !== null
        ? this.model.zipcode
        : defaultNullHtml();
    },
    isDynamic() {
      return Boolean(this.model.has_dynamic_zipcode);
    },
    flagClass() {
      return this.model.country
        ? `flag-icon-${this.model.country.toLowerCase()}`
        : null;
    }
  }
};
</script>
